import React, { useEffect, useState } from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useLocation,
} from 'react-router-dom'
import { Layout, Breadcrumb } from 'antd'
import { connect } from 'react-redux'
import util from '../util/util'
import PropTypes from 'prop-types'
import { PrivateRoute } from '../component'
import '../css/main.scss'

import LoginForm from './signin/signin'
import Patient from './patient/patient'
import PatientView from './patient/patient.view'
import PatientBilling from '../component/patient/patient.billing'
import PatientAdd from './patient/patient.add'
import PatientSchedule from './patient/patient.schedule'
import Surgeons from './surgeons/surgeons'
import SurgeonsAdd from './surgeons/surgeon.add'
import Users from './users/users'
import UsersAdd from './users/users.add'
import Home from './home/home'
import Dashboard from './dashboard/dashboard'
import ResetPassword from './resetpassword/resetpassword'
import Menubar from '../component/header/header'
import { constants } from '../constants'
import Customers from './customers/customers'
import CustomerAdd from './customers/customer.add'
import ClinicSettings from './settings/clinic.settings'
import CompanySettings from './settings/company.settings'
import SystemMaintenance from './settings/system.maintenance'
import Companies from './companies/companies'
import CompanyAdd from './companies/company.add'
import CompanyDetail from './companies/company.detail'
import ExerciseLibrary from './exerciselibrary/exerciselibrary'
import SupportProfile from './supportprofile/supportprofile'
import Messages from './messages/messages'
import Events from './events/events'
import EditDeviceForm from '../component/devices/device.edit'
import EditFeedbackForm from '../component/feedback/feedback'
import ViewCase from '../component/actioncase/actionCase.edit'
import MessageView from '../component/message/message.view'
import createActionCase from '../component/actioncase/actionCase.create'
import Case from './cases/cases'
import Compliance from './compliance/compliance'
import Fullfillment from './fullfillment/fullfillment'
import fullfillmentView from './fullfillment/fullfillment.view'
import Support from './support/support'
import { onMessageListener } from '../config/firebase'
import { useToast } from '../hooks'
import MessagesListing from '../admin-lite/components/message.listing'
import PatientMessage from '../admin-lite/components/patient.messages'
import messageInterface from '../admin-lite/components/message.interface'
// import careplanEdit from '../component/careplan/careplan.edit';

var { ROLE } = constants

const ONLY_ADMINS = [
  ROLE.ADMIN,
  ROLE.COMPANY_ADMIN,
  ROLE.SUPER_ADMIN,
  ROLE.COMPANY_HEALTHCOACH,
]
const COMPANY_USERS = [ROLE.COMPANY_ADMIN, ROLE.COMPANY_HEALTHCOACH]

const { Content, Footer } = Layout

const Main = (props) => {
  const [local, setLocation] = useState(null)
  const { successToast } = useToast()

  let location = useLocation()
  let isAdminLite=location?.search==constants.ADMIN_LITE;
  useEffect(() => setLocation(location), [location])
if(navigator && navigator.serviceWorker && navigator.serviceWorker.addEventListener){

  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'push') {
      console.log('Push message received:', event.data.payload)
    }
  })
}
 

  return (
    <Layout
      style={{
        padding: '0 0 0 0',
        height: '100vh',
        backgroundColor: '#DDDDDD',
      }}
    >
      {props.token != null ? <Menubar /> : null}
      <Content style={{ overflow: 'auto', background: 'white' }}>
        {/* A <Switch> looks through its children <Route>s and
                    renders the first one that matches the current URL.*/}
        <Switch>
          <Route exact path='/'>
            {props.token != null ? (
              props.user?.role === ROLE.COMPANY_ADMIN || props.user?.role === ROLE.COMPANY_HEALTHCOACH ? (
                <Redirect to='/dashboard' />
              ) : (
                <Redirect to='/patient' />
              )
            ) : (
              <Redirect to='/login' />
            )}
          </Route>

          <PrivateRoute path='/resetpassword' exact component={ResetPassword} />

          <PrivateRoute
            path='/patient'
            checkForLogin
            exact
            roles={[
              ROLE.ADMIN,
              ROLE.COMPANY_HEALTHCOACH,
              ROLE.COMPANY_ADMIN,
              ROLE.PHYSIO,
              ROLE.MEDICAL_ASSOCIATE,
              ROLE.SURGEON,
            ]}
            component={Patient}
          />

          <PrivateRoute
            path='/patient/add/:formno'
            checkForLogin
            roles={[
              ROLE.ADMIN,
              ROLE.COMPANY_ADMIN,
              ROLE.PHYSIO,
              ROLE.MEDICAL_ASSOCIATE,
              ROLE.SURGEON,
            ]}
            exact
            component={PatientAdd}
          />

          <PrivateRoute
            path='/patient/edit/:formno'
            checkForLogin
            roles={[
              ROLE.COMPANY_HEALTHCOACH,
              ROLE.COMPANY_ADMIN,
              ROLE.ADMIN,
              ROLE.PHYSIO,
              ROLE.MEDICAL_ASSOCIATE,
              ROLE.SURGEON,
            ]}
            exact
            component={PatientAdd}
          />

          <PrivateRoute
            path='/patient/deviceschedule/:id'
            checkForLogin
            roles={[
              ROLE.ADMIN,
              ROLE.COMPANY_ADMIN,
              ROLE.PHYSIO,
              ROLE.MEDICAL_ASSOCIATE,
              ROLE.SURGEON,
            ]}
            exact
            component={EditDeviceForm}
          />

          <PrivateRoute
            path='/patient/schedule/:id'
            checkForLogin
            roles={[
              ROLE.ADMIN,
              ROLE.COMPANY_ADMIN,
              ROLE.PHYSIO,
              ROLE.MEDICAL_ASSOCIATE,
              ROLE.SURGEON,
            ]}
            exact
            component={PatientSchedule}
          />
          <PrivateRoute
            path='/patient/questionnaireschedule/:id'
            checkForLogin
            roles={[
              ROLE.ADMIN,
              ROLE.COMPANY_ADMIN,
              ROLE.PHYSIO,
              ROLE.MEDICAL_ASSOCIATE,
              ROLE.SURGEON,
            ]}
            exact
            component={EditFeedbackForm}
          />

          <PrivateRoute
            path='/patient/:id/billing'
            checkForLogin
            roles={[
              ROLE.COMPANY_HEALTHCOACH,
              ROLE.COMPANY_ADMIN,
            ]}
            exact
            component={PatientBilling}
          />

          <PrivateRoute
            path='/patient/:id'
            checkForLogin
            roles={[
              ROLE.ADMIN,
              ROLE.COMPANY_HEALTHCOACH,
              ROLE.COMPANY_ADMIN,
              ROLE.PHYSIO,
              ROLE.MEDICAL_ASSOCIATE,
              ROLE.SURGEON,
            ]}
            exact
            component={PatientView}
          />

          {/* <PrivateRoute path="/home" exact roles={[ROLE.ADMIN, ROLE.PHYSIO, ROLE.MEDICAL_ASSOCIATE, ROLE.SURGEON]} component={Home} /> */}

          <PrivateRoute
            path='/surgeons'
            exact
            checkForLogin
            component={Surgeons}
          />

          <PrivateRoute
            path={'/profile/*'}
            exact
            checkForLogin
            component={SurgeonsAdd}
          />

          <PrivateRoute
            path={['/surgeons/add', '/surgeons/edit']}
            exact
            checkForLogin
            component={SurgeonsAdd}
          />

          <PrivateRoute
            roles={ONLY_ADMINS}
            path='/users'
            exact
            checkForLogin
            component={Users}
          />

          <PrivateRoute
            path='/cases'
            exact
            roles={[ROLE.COMPANY_HEALTHCOACH, ROLE.COMPANY_ADMIN]}
            component={Case}
          />

          {/* <PrivateRoute path={["/case/:caseid"]} roles={[ROLE.COMPANY_HEALTHCOACH, ROLE.COMPANY_ADMIN,ROLE.ADMIN,ROLE.SURGEON]} exact component={ViewCase} /> */}
          <PrivateRoute
            path={['/cases/:caseid']}
            roles={[
              ROLE.COMPANY_HEALTHCOACH,
              ROLE.COMPANY_ADMIN,
              ROLE.ADMIN,
              ROLE.SURGEON,
            ]}
            exact
            component={MessageView}
          />
          <PrivateRoute
            path={['/cases-add']}
            roles={[ROLE.COMPANY_HEALTHCOACH, ROLE.COMPANY_ADMIN]}
            exact
            component={createActionCase}
          />

          <PrivateRoute
            roles={ONLY_ADMINS}
            path={['/users/add', '/users/edit']}
            exact
            checkForLogin
            component={UsersAdd}
          />

          <PrivateRoute
            roles={ONLY_ADMINS}
            path='/cusers'
            back='/cusers'
            exact
            checkForCompanyLogin
            component={Users}
          />
          <PrivateRoute
            roles={[ROLE.COMPANY_ADMIN, ROLE.COMPANY_HEALTHCOACH]}
            path='/dashboard'
            exact
            checkForCompanyLogin
            component={Dashboard}
          />
          <PrivateRoute
            roles={ONLY_ADMINS}
            path='/fulfillment'
            back='/fulfillment'
            exact
            checkForCompanyLogin
            component={Fullfillment}
          />
          <PrivateRoute
            roles={ONLY_ADMINS}
            path='/fulfillment/:fulfillmentid'
            back='/fulfillment'
            exact
            checkForCompanyLogin
            component={fullfillmentView}
          />

          <PrivateRoute
            roles={ONLY_ADMINS}
            path={['/cusers/add', '/cusers/edit']}
            back='/cusers'
            exact
            checkForCompanyLogin
            component={UsersAdd}
          />

          <PrivateRoute
            path={['/customers', '/customers/:companyid']}
            roles={[
              ROLE.COMPANY_ADMIN,
              ROLE.COMPANY_HEALTHCOACH,
              ROLE.SUPER_ADMIN,
            ]}
            exact
            checkForCompanyLogin
            component={Customers}
          />

          <PrivateRoute
            path={['/customers/add/customer', '/customers/edit/:id']}
            roles={[
              ROLE.COMPANY_ADMIN,
              ROLE.COMPANY_HEALTHCOACH,
              ROLE.SUPER_ADMIN,
            ]}
            exact
            component={CustomerAdd}
          />

          <PrivateRoute
            path='/clinicsettings'
            roles={[ROLE.COMPANY_ADMIN, ROLE.COMPANY_HEALTHCOACH]}
            exact
            checkForCompanyLogin
            component={ClinicSettings}
          />
          <PrivateRoute
            path='/companysettings'
            roles={[ROLE.COMPANY_ADMIN, ROLE.COMPANY_HEALTHCOACH]}
            exact
            checkForCompanyLogin
            component={CompanySettings}
          />

          <PrivateRoute
            path='/exerciselibrary'
            roles={[ROLE.COMPANY_ADMIN, ROLE.SUPER_ADMIN]}
            exact
            component={ExerciseLibrary}
          />

          <PrivateRoute
            path='/supportprofile'
            roles={[ROLE.COMPANY_ADMIN, ROLE.SUPER_ADMIN]}
            exact
            component={SupportProfile}
          />

          <PrivateRoute
            path='/companies'
            roles={[ROLE.SUPER_ADMIN]}
            exact
            component={Companies}
          />

          <PrivateRoute
            path='/systemmaintenance'
            roles={[ROLE.SUPER_ADMIN]}
            exact
            component={SystemMaintenance}
          />

          <PrivateRoute
            path={['/companies/add', '/companies/edit/:id']}
            roles={[ROLE.SUPER_ADMIN]}
            exact
            component={CompanyAdd}
          />

          <PrivateRoute
            path={['/companies/:id/users/add', '/companies/:id/users/edit']}
            roles={[ROLE.SUPER_ADMIN]}
            exact
            checkForCompanyLogin
            component={UsersAdd}
          />

          <PrivateRoute
            path='/companies/:id'
            roles={[ROLE.SUPER_ADMIN]}
            exact
            checkForCompanyLogin
            component={CompanyDetail}
          />

          <PrivateRoute
            path={['/inbox']}
            roles={[ROLE.SURGEON, ROLE.MEDICAL_ASSOCIATE]}
            exact
            component={Messages}
          />

          <PrivateRoute
            path={['/notification']}
            roles={ONLY_ADMINS}
            exact
            component={Messages}
          />

          <PrivateRoute
            path={['/events']}
            roles={ONLY_ADMINS}
            exact
            component={Events}
          />

          <PrivateRoute
            path={['/support']}
            checkForLogin
            roles={[
              ROLE.ADMIN,
              ROLE.COMPANY_ADMIN,
              ROLE.SURGEON,
              ROLE.MEDICAL_ASSOCIATE,
            ]}
            exact
            component={Support}
          />
          <PrivateRoute
            path={['/messages']}
            checkForLogin
            roles={[
              ROLE.ADMIN,
              ROLE.SURGEON,
              ROLE.COMPANY_ADMIN,      // DEBUG: Added for company access (REMOVE AFTER TESTING)
              ROLE.COMPANY_HEALTHCOACH, // DEBUG: Added for company access (REMOVE AFTER TESTING)
            ]}
            exact
            component={MessagesListing}
          />
          <PrivateRoute
            path={['/patient-message']}
            checkForLogin
            roles={[
              ROLE.ADMIN,
              ROLE.SURGEON,
            ]}
            exact
            component={PatientMessage}
          />
          <PrivateRoute
            path={['/message-interface']}
            checkForLogin
            roles={[
              ROLE.ADMIN,
              ROLE.SURGEON,
            ]}
            exact
            component={messageInterface}
          />
          <PrivateRoute
            path={['/compliance']}
            checkForLogin
            roles={[
              ROLE.ADMIN,
              ROLE.COMPANY_ADMIN,
              ROLE.SURGEON,
              ROLE.MEDICAL_ASSOCIATE,
            ]}
            exact
            component={Compliance}
          />
         

          {/* <PrivateRoute path={["/careplan"]} checkForLogin roles={[ROLE.ADMIN]} exact component={careplanEdit} /> */}

          <Route exact path='/login'>
            {' '}
            <LoginForm />{' '}
          </Route>
        </Switch>
      </Content>
     {!isAdminLite && <Footer className='main-footer'>{util.getCopyrightText()}</Footer>}
    </Layout>
  )
}

Main.propTypes = {
  token: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    token: util.verifyToken(state.profile.token),
    user: state.profile.user,
  }
}

export default connect(mapStateToProps, null)(Main)
